let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kCxTP")).then(() => parcelRequire('5KYHN'));